export class FiltrosRepCobranzas{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'facturas_vencidas';
 
 }